// extracted by mini-css-extract-plugin
export var item = "tile-module--item--mRfkF";
export var visual = "tile-module--visual--pmJW9";
export var title = "tile-module--title--P4nda";
export var ad = "tile-module--ad--90slv";
export var fadein = "tile-module--fadein--S50Pj";